import { render, staticRenderFns } from "./ExchangeRatePopup.vue?vue&type=template&id=39b3471f"
import script from "./ExchangeRatePopup.vue?vue&type=script&lang=js"
export * from "./ExchangeRatePopup.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRatePopup.vue?vue&type=style&index=0&id=39b3471f&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports